var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex align-middle justify-center"},[_c('Icono',{attrs:{"nombre":_vm.icono}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.mensaje)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }